import React from 'react'
import { Link } from 'react-router-dom'
import blog_data from "../Data/about_blogs.json"
import { BsFillCalendar2EventFill } from "react-icons/bs"

const BlogBlock = () => {
  return (
    <>
        <div className="container blog-container">
            <h3 className="section-subtitle">AutoInsure</h3>
            <h1 className="section-title">Our Blogs</h1>
            <p className="section-caption blog-caption">Here are some car insurance & rental car blogs written by our employees:</p>
            <div className="blog-box">
                {blog_data.map((i) => {
                    return (
                        <div className="blog-card">
                            <div className="blog-img-container">
                                <img src={i.img} alt="blog" />
                            </div>
                            <div className="blog-info-container">
                                <h2 className="blog-title">{
                                i.title}</h2>
                                <p className="blog-description">{i.subtitle}</p>
                                <Link to={i.link} target="_blank">
                                    <span className="read-blog yellow">Read Blog</span>
                                </Link>
                                <div className="blog-line"></div>
                                <div className="blog-publish-info">
                                    <div className="publish-img-container">
                                        <img src={i.author_img} alt="author" />
                                    </div>
                                    <span className="author-name">{i.author}</span>
                                    <span className="date-icon"><BsFillCalendar2EventFill/></span>
                                    <span className="date">{i.date}</span>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <span className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Back To Top</span>
        </div>
    </>
  )
}

export default BlogBlock